module.exports = __webpack_public_path__ + "static/media/l6.ba7ef23d.jpg";